import React from 'react'

import 'app/components/display/grey_container/style.scss'

const GreyContainer = ({ children, containerClass = '' }) => {
  return <div className={`grey-container ${containerClass}`}>{children}</div>
}

export default GreyContainer
